module.exports = __webpack_public_path__ + "img/plus.93c0887c.svg";